import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import {
  faCar,
  faCog,
  faDriversLicense,
  faEarth,
  faEarthEurope,
  faGlobe,
  faLanguage,
  faMap,
  faPassport,
  faRuler,
  faTable,
  faUserSecret,
  faVcard,
  faVialCircleCheck,
} from "@fortawesome/free-solid-svg-icons";
import { PAGES_CONFIG } from "pages/pagesConfig";

export interface SidebarRoute {
  title: string;
  path?: string;
  icon?: IconDefinition;
  subRoutes?: SidebarRoute[];
  permissions?: string[];
  notShowInSidebar?: boolean;
}

export const routes: SidebarRoute[] = Object.values(PAGES_CONFIG).map(
  (config) => ({
    title: config.routeName,
    path: config.path,
    icon: config.icon,
    subRoutes: config?.subRoutes?.map((subRoute) => ({
      title: subRoute.title,
      path: subRoute.path,
    })),
    permissions: config?.permissions,
    notShowInSidebar: config?.notShowInSidebar,
  })
);

// export const routes: SidebarRoute[] = [
//   {
//     title: "management",
//     icon: faCog,
//     subRoutes: [
//       {
//         title: "roles",
//         path: "/management/roles",
//         permissions: ["read:roles"],
//         icon: faRuler,
//       },
//       {
//         title: "admins",
//         path: "/management/admin",
//         permissions: ["read:admin"],
//         icon: faUserSecret,
//       },
//       {
//         title: "languages",
//         path: "/management/languages",
//         permissions: ["read:languages"],
//         icon: faLanguage,
//       },
//       // ... other management routes
//     ],
//   },
//   {
//     title: "visa",
//     icon: faPassport,
//     subRoutes: [
//       {
//         title: "continents",
//         path: "/visa/continents",
//         permissions: ["read:continents"],
//         icon: faEarthEurope,
//       },
//       {
//         title: "countries",
//         path: "/visa/countries",
//         permissions: ["read:countries"],
//         icon: faGlobe,
//       },
//       {
//         title: "cities",
//         path: "/visa/cities",
//         permissions: ["read:cities"],
//         icon: faMap,
//       },
//       {
//         title: "visaTypes",
//         path: "/visa/visaTypes",
//         permissions: ["read:visaTypes"],
//         icon: faVcard,
//       },
//       {
//         title: "countryPairs",
//         path: "/visa/countryPairs",
//         permissions: ["read:countryPairs"],
//         icon: faEarth,
//       },
//       {
//         title: "visaApplicationForms",
//         path: "/visa/visaApplicationForms",
//         permissions: ["read:visaApplicationForms"],
//         icon: faTable,
//       },
//       {
//         title: "visaApplications",
//         path: "/visa/visaApplications",
//         permissions: ["read:visaApplications"],
//         icon: faVialCircleCheck,
//       },
//     ],
//   },
//   {
//     title: "license",
//     icon: faDriversLicense,
//     subRoutes: [
//       {
//         title: "drivingLicenses",
//         path: "/license/drivingLicenses",
//         permissions: ["read:drivingLicenses"],
//         icon: faCar,
//       },
//       {
//         title: "drivingLicenseApplications",
//         path: "/license/drivingLicenseApplications",
//         permissions: ["read:drivingLicenseApplications"],
//         icon: faVialCircleCheck,
//       },
//     ],
//   },
// ];
